import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Submit/VERIFICATION_ERROR',
    PENDING: 'Submit/VERIFICATION_PENDING',
    SUCCESS: 'Submit/VERIFICATION_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
